import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  isCommercialList,
  isEpicShow,
} from '@epicuro-next/features/engagement/list-utils';
import { List, LookBook } from '@epicuro-next/models/engagement';
import {
  selectShopTheListLoading,
  shopTheList,
} from '@epicuro-next/state/product-list-state';
import {
  selectIsSalesRepOrAdmin,
  selectUser,
} from '@epicuro-next/state/user-state';
import { isNonNullish } from '@epicuro-next/utilities';
import { select, Store } from '@ngrx/store';
import { combineLatest, ReplaySubject } from 'rxjs';
import { filter, map, shareReplay } from 'rxjs/operators';

import {
  SHOP_THE_LIST_LOADING,
  SHOP_THE_LIST_TEXT,
  SHOP_THE_LOOK_TEXT,
} from '../../../../engagement-header/src/lib/constants';

@Component({
  selector: 'epc-list-call-to-action-button',
  templateUrl: './list-call-to-action-button.component.html',
  styleUrls: ['./list-call-to-action-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ListCallToActionButtonComponent {
  public shopTheListText = SHOP_THE_LIST_TEXT;
  public shopTheLookText = SHOP_THE_LOOK_TEXT;
  public shopTheListLoadingText = SHOP_THE_LIST_LOADING;

  public list$ = new ReplaySubject<List>();

  @Input()
  public set list(list: List) {
    this.list$.next(list);
  }

  @Input()
  public lookBook?: LookBook;

  public shopListLoading$ = this.store.pipe(
    select(selectShopTheListLoading),
    shareReplay({ bufferSize: 1, refCount: true }),
  );
  public isCommercialList = isCommercialList;
  public isEpicShow = isEpicShow;

  private isOwner$ = combineLatest([
    this.store.pipe(select(selectUser), filter(isNonNullish)),
    this.list$.pipe(filter(isNonNullish)),
  ]).pipe(
    map(([user, list]) => user?.externalId === list.creation.user?.externalId),
  );

  public shopTheListDisabled$ = combineLatest([
    this.list$,
    this.store.pipe(select(selectIsSalesRepOrAdmin)),
    this.isOwner$,
    this.shopListLoading$,
  ]).pipe(
    map(([list, isSalesRepOrAdmin, isOwner, loading]) => {
      const ownerOfEpicShow = isOwner && isEpicShow(list);
      const userConsumingEpicShow =
        !isSalesRepOrAdmin && !isOwner && isEpicShow(list);
      const hasProductsToBuy = (list.availableProductsCount ?? 0) > 0;

      if (loading || !hasProductsToBuy) return true;
      if (isSalesRepOrAdmin) return false;
      if (userConsumingEpicShow) return true;
      if (ownerOfEpicShow) return false;
      return false;
    }),
  );

  constructor(private store: Store) {}

  public shopTheList() {
    this.store.dispatch(shopTheList());
  }

  public get buttonText() {
    return this.lookBook ? this.shopTheLookText : this.shopTheListText;
  }
}
